import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Logo from "./partials/Logo";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import cookies from "js-cookie";
import { languages } from "../../../src/utils/Language";
import ReactFlagsSelect from "react-flags-select";
import { useLocation } from "react-router-dom";

const propTypes = {
  navPosition: PropTypes.string,
  hideNav: PropTypes.bool,
  hideSignin: PropTypes.bool,
  bottomOuterDivider: PropTypes.bool,
  bottomDivider: PropTypes.bool,
};

const defaultProps = {
  navPosition: "",
  hideNav: false,
  hideSignin: false,
  bottomOuterDivider: false,
  bottomDivider: false,
};

const Header = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {
  const search = useLocation().search;
  const searchParams = new URLSearchParams(search);
  let lang =
    searchParams.get("lang") ||
    cookies.get("i18next") ||
    navigator.userLanguage;

  var currentLanguage = languages.find((l) => l.code == lang);

  const { t } = useTranslation();
  const [select, setSelect] = useState("GB");
  const onSelect = async (code) => {
    await setSelect(code);
    const selectedLangugae = languages.find((l) => l.country_code === code);
    i18next.changeLanguage(selectedLangugae.code);
  };

  useEffect(() => {
    console.log("Setting page lang  :  " + lang);
    if (currentLanguage == undefined || currentLanguage == null) {
      currentLanguage = languages.find((l) => l.code === "en");
    }
    console.log("Setting page lang2  :  " + currentLanguage.code);
    i18next.changeLanguage(currentLanguage.code);
    setSelect(currentLanguage.country_code);
    document.body.dir = currentLanguage.dir || "ltr";
    document.title = "Waap";
  }, [currentLanguage]);

  const classes = classNames(
    "site-header",
    bottomOuterDivider && "has-bottom-divider",
    className
  );

  return (
    <header {...props} className={classes}>
      <div className="container">
        <div
          className={classNames(
            "site-header-inner",
            bottomDivider && "has-bottom-divider"
          )}
        >
          <Logo />
          <label onClick={(e) => console.log("hi")}>
            <ReactFlagsSelect
              selected={select}
              onSelect={onSelect}
              countries={[
                "TR",
                "GB",
                "SA",
                "DE",
                "ES",
                "IR",
                "PH",
                "FR",
                "IN",
                "ID",
                "IT",
                "JP",
                "KR",
                "MY",
                "PT",
                "RU",
                "TH",
                "UA",
                "PK",
                "VN",
                "CN",
              ]}
              customLabels={{
                TR: "Türkçe",
                GB: "English",
                SA: "عربى",
                DE: "Deutsch",
                ES: "Española",
                IR: "فارسی",
                PH: "Pilipinas",
                FR: "Français",
                IN: "हिंदी",
                ID: "Bahasa Indonesia",
                IT: "Italiana",
                JP: "日本",
                KR: "한국인",
                MY: "Malaysia",
                PT: "Português",
                RU: "Русский",
                TH: "แบบไทย",
                UA: "українська",
                PK: "اردو",
                VN: "Tiếng Việt",
                CN: "中国人",
              }}
              searchable={false}
              optionsSize={16}
              selectedSize={16}
              selectButtonClassName={"qrContainer"}
            />
          </label>
        </div>
      </div>
    </header>
  );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
